module.exports = __webpack_public_path__ + "static/media/LK.b0fc76d2.png";